import React from "react";
import { Reveal } from "@/components/shared/Reveal";

export const SectionHeading = ({ eyebrow, title, description, align = "left", dark = false, className = "" }) => {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <Reveal className={`flex flex-col ${alignCls} max-w-2xl ${className}`}>
      {eyebrow && (
        <span
          className={`text-sm font-semibold uppercase tracking-[0.25em] mb-4 inline-flex items-center gap-2 ${
            dark ? "text-brand-sky" : "text-brand-accent"
          }`}
          data-testid="section-eyebrow"
        >
          <span className={`h-px w-8 ${dark ? "bg-brand-sky" : "bg-brand-accent"}`} />
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-heading font-extrabold tracking-tighter leading-[1.05] text-4xl sm:text-5xl ${
          dark ? "text-white" : "text-ink"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-white/70" : "text-muted-foreground"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
};
